import { render, staticRenderFns } from "./QuotationHistoryModal.vue?vue&type=template&id=34fec676&scoped=true&"
import script from "./QuotationHistoryModal.vue?vue&type=script&lang=js&"
export * from "./QuotationHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fec676",
  null
  
)

export default component.exports